"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateEnrichedAttributeCell = void 0;
const react_1 = require("react");
const product_values_1 = require("../../../../../../client/product-values");
const product_table_1 = require("../../../../../../common/product-table");
const attributes_1 = require("../../../../../../constants/attributes");
const localization_1 = require("../../../../../../../localization");
const useUpdateEnrichedAttributeCell = () => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { createProductValue } = (0, product_values_1.useCreateProductValue)();
    const { deleteProductValue } = (0, product_values_1.useDeleteProductValue)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const updateAttributeCell = (0, react_1.useCallback)((productId, nextValues, prevValues, attributeId) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const specialAttributeValueLabel = t({ key: attributes_1.SpecialAttributeValueToLocalizationKey[attributes_1.SpecialAttributeValue.NotApplicable] });
        const { valuesToCreate, valuesToDelete } = (0, product_table_1.getAttributeValueChanges)(nextValues, prevValues, specialAttributeValueLabel);
        if (!valuesToCreate.length && !valuesToDelete.length) {
            return undefined;
        }
        setIsLoading(true);
        try {
            // Sequential execution: DELETE must see CREATE result to return correct final state
            let finalResult = null;
            if (valuesToCreate.length) {
                const values = valuesToCreate.map((value) => ({ name: value === specialAttributeValueLabel ? attributes_1.SpecialAttributeValue.NotApplicable : value, description: '' }));
                const formData = [{
                        name: attributeId,
                        description: '',
                        values,
                    }];
                const createResults = yield createProductValue(formData, [productId], attributeId);
                [finalResult] = createResults;
            }
            if (valuesToDelete.length) {
                const values = valuesToDelete.map((value) => (value === specialAttributeValueLabel ? attributes_1.SpecialAttributeValue.NotApplicable : value));
                const deleteResults = yield deleteProductValue(values, attributeId, [productId]);
                [finalResult] = deleteResults;
            }
            return (_a = finalResult === null || finalResult === void 0 ? void 0 : finalResult.product) !== null && _a !== void 0 ? _a : undefined;
        }
        finally {
            setIsLoading(false);
        }
    }), [createProductValue, deleteProductValue, t]);
    return {
        updateAttributeCell,
        isLoading,
    };
};
exports.useUpdateEnrichedAttributeCell = useUpdateEnrichedAttributeCell;
